
export const inactiveColor = "3px dotted transparent";
export const activeColor = "3px dotted red";
export const canDropColor = "3px dotted #CCCCCC";